module.exports = __webpack_public_path__ + "img/add-manually.0af10f93.svg";